import useTranslation from 'next-translate/useTranslation';

import blockedLanguageList from '../constants/blockedLanguage.const';

export const useIsBlockedLanguage = () => {
  const { t } = useTranslation('common');

  const validateBlockedLanguage = (string, fieldName) => {
    if (blockedLanguageList.includes(string.toLowerCase())) {
      return {
        isValid: false,
        message: t('errors.generic.invalidX', { value: fieldName }),
      };
    }
    const stringArray = string.split(' ');

    const individualWordErrors = stringArray
      .map((str: string) =>
        blockedLanguageList.includes(str.toLowerCase()) ? str.toLowerCase() : null
      )
      .filter((str) => str);

    if (individualWordErrors.length > 0) {
      return {
        isValid: false,
        message: t('errors.generic.invalidX', { value: fieldName }),
      };
    }

    return {
      isValid: true,
      message: '',
    };
  };
  return validateBlockedLanguage;
};
